export default {
  massRemove: 'Supprimer les règles de flapping',
  massEnable: 'Activer les règles de flapping',
  massDisable: 'Désactiver les règles de flapping',
};
